import { render, staticRenderFns } from "./NotificationTimeline.vue?vue&type=template&id=db4192f0&scoped=true&"
import script from "./NotificationTimeline.vue?vue&type=script&lang=ts&"
export * from "./NotificationTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4192f0",
  null
  
)

export default component.exports